import React, { Component } from "react";
import axios from "axios";
import { Spin } from "antd";
import Bridge from "../../utils/Bridge";
import {RESEARCH_TYPE} from '../../utils/consts';
import ProgressionChart from './ProgressionChart';

export default class AlsfrsBreakdown extends Component {
  constructor(props) {
    super(props);
    this.state = {
      client_code: "",
      records: [],
      roads_list:[],
      loading: false,
      is_loaded:false
    };
  }
  componentDidMount() {
    this.get_alsfrs_breakdown();
    if(RESEARCH_TYPE=='modality.ai'){
      this.get_roads_breakdown()
      if(this.props.client_code){
        this.setState({
          client_code:this.props.client_code,
          is_loaded:true
        })
      }
    }
  }
  get_alsfrs_breakdown = () => {
    const HIDE_QUESTIONS = ["Gastrostomy"];
    let client_code = this.props.client_code;
    this.setState({ loading: true });
    let params = `/${client_code}?stat=surveybreakdown&surveyId=ALSFRSR`;
    Bridge.personal_data_viewer
      .get_alsfrs_breakdown(params)
      .then((res) => {
        let data = res.data.results;
        let arr = [];
        for (let item of data) {
          let obj = {
            date: "",
            speech_label: "",
            speech_score: 0,
            salivation_label: "",
            salivation_score: 0,
            swallowing_label: "",
            swallowing_score: 0,
            handwriting_label: "",
            handwriting_score: 0,
            gastrostomy_label: "",
            gastrostomy_score: 0,
            cuttingfood_label: "",
            cuttingfood_score: 0,
            dressingandhygiene_label: "",
            dressingandhygiene_score: 0,
            turninginbed_label: "",
            turninginbed_score: 0,
            walking_label: "",
            walking_score: 0,
            climbingstairs_label: "",
            climbingstairs_score: 0,
            dyspnea_label: "",
            dyspnea_score: 0,
            orthopnea_label: "",
            orthopnea_score: 0,
            respiratoryinsufficiency_label: "",
            respiratoryinsufficiency_score: 0,
            total_score: 0,
          };
          let processedLabels = new Set(); // Use a Set to track processed labels
          for (let category of item.categories) {
            if (!processedLabels.has(category.label)) {
              processedLabels.add(category.label);
              if (category.label == "Speech") {
                obj.speech_label = category.label;
                obj.speech_score = category.score;
              }
              if (category.label == "Salivation") {
                obj.salivation_label = category.label;
                obj.salivation_score = category.score;
              }
              if (category.label == "Swallowing") {
                obj.swallowing_label = category.label;
                obj.swallowing_score = category.score;
              }
              if (category.label == "Handwriting") {
                obj.handwriting_label = category.label;
                obj.handwriting_score = category.score;
              }
              if (category.label == "Gastrostomy") {
                obj.gastrostomy_label = category.label;
                obj.gastrostomy_score = category.score;
              }
              if (category.label == "Cutting Food") {
                obj.cuttingfood_label = category.label;
                obj.cuttingfood_score = category.score;
              }
              if (category.label == "Dressing and Hygiene") {
                obj.dressingandhygiene_label = category.label;
                obj.dressingandhygiene_score = category.score;
              }
              if (category.label == "Turning in bed") {
                obj.turninginbed_label = category.label;
                obj.turninginbed_score = category.score;
              }
              if (category.label == "Walking") {
                obj.walking_label = category.label;
                obj.walking_score = category.score;
              }
              if (category.label == "Climbing stairs") {
                obj.climbingstairs_label = category.label;
                obj.climbingstairs_score = category.score;
              }
              if (category.label == "Dyspnea") {
                obj.dyspnea_label = category.label;
                obj.dyspnea_score = category.score;
              }
              if (category.label == "Orthopnea") {
                obj.orthopnea_label = category.label;
                obj.orthopnea_score = category.score;
              }
              if (category.label == "Respiratory insufficiency") {
                obj.respiratoryinsufficiency_label = category.label;
                obj.respiratoryinsufficiency_score = category.score;
              }
              // obj.total_score =
              //   obj.speech_score +
              //   obj.salivation_score +
              //   obj.swallowing_score +
              //   obj.dressingandhygiene_score +
              //   obj.turninginbed_score +
              //   obj.walking_score +
              //   obj.climbingstairs_score +
              //   obj.dyspnea_score +
              //   obj.orthopnea_score +
              //   obj.respiratoryinsufficiency_score;
              obj.date = item.date;
            }
          }
          arr.push(obj);
        }
        arr.sort((a, b) => new Date(b.date) - new Date(a.date));

        let with_total=[]
        for(let item of arr){
          item.total=
          Number(item.climbingstairs_score)+
          Number(item.cuttingfood_score)+
          Number(item.dressingandhygiene_score)+
          Number(item.dyspnea_score)+
          Number(item.gastrostomy_score)+
          Number(item.handwriting_score)+
          Number(item.orthopnea_score)+
          Number(item.respiratoryinsufficiency_score)+
          Number(item.salivation_score)+
          Number(item.speech_score)+
          Number(item.swallowing_score)+
          Number(item.total_score)+
          Number(item.turninginbed_score)+
          Number(item.walking_score)
          with_total.push(item)
        }
        this.setState({ records: with_total, loading: false });
      })
      .catch((err) => {
        this.setState({ loading: false });
      });
  };
  get_roads_breakdown = () => {
    let client_code = this.props.client_code;
    this.setState({ loading: true });
    let params = `/${client_code}?stat=surveybreakdown&surveyId=ROADS`;
    Bridge.personal_data_viewer
      .get_roads_breakdown(params)
      .then((res) => {
        let data = res.data.results;
        let arr = [];
        for (let item of data) {
          let obj = {
            date: "",
            nod_yes_or_no_label: "",
            nod_yes_or_no_score:0,
            ride_in_a_car_label: "",
            ride_in_a_car_score:0,
            eat_soup_label: "",
            eat_soup_score:0,
            drink_milkshake_or_smoothie_label: "",
            drink_milkshake_or_smoothie_score:0,
            sit_on_a_toilet_label: "",
            sit_on_a_toilet_score:0,
            swallow_pills_label: "",
            swallow_pills_score:0,
            blow_out_a_candle_label: "",
            blow_out_a_candle_score:0,
            eat_dry_food_label: "",
            eat_dry_food_score:0,
            speak_on_the_phone_label: "",
            speak_on_the_phone_score:0,
            drink_out_of_a_glass_label: "",
            drink_out_of_a_glass_score:0,
            eat_a_large_meal_label: "",
            eat_a_large_meal_score:0,
            sign_name_on_paper_label: "",
            sign_name_on_paper_score:0,
            get_into_bed_label: "",
            get_into_bed_score:0,
            roll_over_in_bed_label: "",
            roll_over_in_bed_score:0,
            take_a_shower_label: "",
            take_a_shower_score:0,
            use_a_knife_and_fork_label: "",
            use_a_knife_and_fork_score:0,
            walk_around_your_home_label: "",
            walk_around_your_home_score:0,
            move_a_chair_label: "",
            move_a_chair_score:0,
            speak_in_a_loud_room_label: "",
            speak_in_a_loud_room_score:0,
            speak_for_hours_label: "",
            speak_for_hours_score:0,
            clip_nails_label: "",
            clip_nails_score:0,
            walk_up_1_flight_of_stairs_label: "",
            walk_up_1_flight_of_stairs_score:0,
            walk_up_a_hill_label: "",
            walk_up_a_hill_score:0,
            climb_a_stepstool_label: "",
            climb_a_stepstool_score:0,
            get_up_from_the_floor_label: "",
            get_up_from_the_floor_score:0,
            carry_an_object_going_downstairs_label: "",
            carry_an_object_going_downstairs_score:0,
            stand_for_hours_label: "",
            stand_for_hours_score:0,
            get_heavy_objects_off_a_high_shelf_label: "",
            get_heavy_objects_off_a_high_shelf_score:0,
            total: 0,
          };
          let processedLabels = new Set(); // Use a Set to track processed labels
          for (let category of item.categories) {
            if (!processedLabels.has(category.label)) {
              processedLabels.add(category.label);
              if (category.label == "Nod yes or no") {
                obj.nod_yes_or_no_label = category.label;
                obj.nod_yes_or_no_score = category.score;
              }
              if (category.label == "Ride in a car") {
                obj.ride_in_a_car_label = category.label;
                obj.ride_in_a_car_score = category.score;
              }
              if (category.label == "Eat soup") {
                obj.eat_soup_label = category.label;
                obj.eat_soup_score = category.score;
              }
              if (category.label == "Drink milkshake or smoothie") {
                obj.drink_milkshake_or_smoothie_label = category.label;
                obj.drink_milkshake_or_smoothie_score = category.score;
              }
              if (category.label == "Sit on a toilet") {
                obj.sit_on_a_toilet_label = category.label;
                obj.sit_on_a_toilet_score = category.score;
              }
              if (category.label == "Swallow pills") {
                obj.swallow_pills_label = category.label;
                obj.swallow_pills_score = category.score;
              }
              if (category.label == "Blow out a candle") {
                obj.blow_out_a_candle_label = category.label;
                obj.blow_out_a_candle_score = category.score;
              }
              if (category.label == "Eat dry food") {
                obj.eat_dry_food_label = category.label;
                obj.eat_dry_food_score = category.score;
              }
              if (category.label == "Speak on the phone") {
                obj.speak_on_the_phone_label = category.label;
                obj.speak_on_the_phone_score = category.score;
              }
              if (category.label == "Drink out of a glass") {
                obj.drink_out_of_a_glass_label = category.label;
                obj.drink_out_of_a_glass_score = category.score;
              }
              if (category.label == "Eat a large meal") {
                obj.eat_a_large_meal_label = category.label;
                obj.eat_a_large_meal_score = category.score;
              }
              if (category.label == "Sign name on paper") {
                obj.sign_name_on_paper_label = category.label;
                obj.sign_name_on_paper_score = category.score;
              }
              if (category.label == "Get into bed") {
                obj.get_into_bed_label = category.label;
                obj.get_into_bed_score = category.score;
              }
              if (category.label == "Roll over in bed") {
                obj.roll_over_in_bed_label = category.label;
                obj.roll_over_in_bed_score = category.score;
              }
              if (category.label == "Take a shower") {
                obj.take_a_shower_label = category.label;
                obj.take_a_shower_score = category.score;
              }
              if (category.label == "Use a knife and fork") {
                obj.use_a_knife_and_fork_label = category.label;
                obj.use_a_knife_and_fork_score = category.score;
              }
              if (category.label == "Walk around your home") {
                obj.walk_around_your_home_label = category.label;
                obj.walk_around_your_home_score = category.score;
              }
              if (category.label == "Move a chair") {
                obj.move_a_chair_label = category.label;
                obj.move_a_chair_score = category.score;
              }
              if (category.label == "Speak in a loud room") {
                obj.speak_in_a_loud_room_label = category.label;
                obj.speak_in_a_loud_room_score = category.score;
              }
              if (category.label == "Speak for hours") {
                obj.speak_for_hours_label = category.label;
                obj.speak_for_hours_score = category.score;
              }
              if (category.label == "Clip nails") {
                obj.clip_nails_label = category.label;
                obj.clip_nails_score = category.score;
              }
              if (category.label == "Walk up 1 flight of stairs") {
                obj.walk_up_1_flight_of_stairs_label = category.label;
                obj.walk_up_1_flight_of_stairs_score = category.score;
              }
              if (category.label == "Walk up a hill") {
                obj.walk_up_a_hill_label = category.label;
                obj.walk_up_a_hill_score = category.score;
              }
              if (category.label == "Climb a stepstool") {
                obj.climb_a_stepstool_label = category.label;
                obj.climb_a_stepstool_score = category.score;
              }
              if (category.label == "Get up from the floor") {
                obj.get_up_from_the_floor_label = category.label;
                obj.get_up_from_the_floor_score = category.score;
              }
              if (category.label == "Carry an object going downstairs") {
                obj.carry_an_object_going_downstairs_label = category.label;
                obj.carry_an_object_going_downstairs_score = category.score;
              }
              if (category.label == "Stand for hours") {
                obj.stand_for_hours_label = category.label;
                obj.stand_for_hours_score = category.score;
              }
              if (category.label == "Get heavy objects off a high shelf") {
                obj.get_heavy_objects_off_a_high_shelf_label = category.label;
                obj.get_heavy_objects_off_a_high_shelf_score = category.score;
              }
              obj.date = item.date;
            }
          }
          arr.push(obj);
        }
        // arr.sort((a, b) => new Date(b.date) - new Date(a.date));

        let with_total=[]
        for(let item of arr){
          item.total=
          Number(item.nod_yes_or_no_score)+
          Number(item.ride_in_a_car_score)+
          Number(item.eat_soup_score)+
          Number(item.drink_milkshake_or_smoothie_score)+
          Number(item.sit_on_a_toilet_score)+
          Number(item.swallow_pills_score)+
          Number(item.blow_out_a_candle_score)+
          Number(item.eat_dry_food_score)+
          Number(item.speak_on_the_phone_score)+
          Number(item.drink_out_of_a_glass_score)+
          Number(item.eat_a_large_meal_score)+
          Number(item.sign_name_on_paper_score)+
          Number(item.get_into_bed_score)+
          Number(item.roll_over_in_bed_score)+
          Number(item.take_a_shower_score)+
          Number(item.use_a_knife_and_fork_score)+
          Number(item.walk_around_your_home_score)+
          Number(item.move_a_chair_score)+
          Number(item.speak_in_a_loud_room_score)+
          Number(item.speak_for_hours_score)+
          Number(item.clip_nails_score)+
          Number(item.walk_up_1_flight_of_stairs_score)+
          Number(item.walk_up_a_hill_score)+
          Number(item.climb_a_stepstool_score)+
          Number(item.get_up_from_the_floor_score)+
          Number(item.carry_an_object_going_downstairs_score)+
          Number(item.stand_for_hours_score)+
          Number(item.get_heavy_objects_off_a_high_shelf_score)
          with_total.push(item)
        }
        this.setState({ roads_list: with_total, loading: false });
      })
      .catch((err) => {
        this.setState({ loading: false });
      });
  };
  render() {
    const customStyle = {
      fontSize: "19px",
      textAlign: "center",
      padding: "16px 0 0 0",
    };
    return (
      <div className="row alsfrs-breakdown-container">
        <div className="col-md-12">

          {RESEARCH_TYPE=='modality.ai' && (
            <div>
              <ul class="nav nav-pills mb-3 mt-3" id="pills-tab" role="tablist">
                <li class="nav-item" role="presentation">
                  <button class="nav-link disabled" id="pills-home-tab" type="button" role="tab" aria-controls="pills-home" aria-selected="true">View</button>
                </li>
                <li class="nav-item" role="presentation">
                  <button class="nav-link active" id="pills-profile-tab" data-bs-toggle="pill" data-bs-target="#pills-profile" type="button" role="tab" aria-controls="pills-profile" aria-selected="false">ALSFRS</button>
                </li>
                <li class="nav-item" role="presentation">
                  <button class="nav-link" id="pills-contact-tab" data-bs-toggle="pill" data-bs-target="#pills-contact" type="button" role="tab" aria-controls="pills-contact" aria-selected="false">ROADS</button>
                </li>
              </ul>
              <div class="tab-content" id="pills-tabContent">
                <div class="tab-pane fade show active" id="pills-profile" role="tabpanel" aria-labelledby="pills-profile-tab">
                  <Spin spinning={this.state.loading}>
                    {this.state.records.length > 0 && (
                      <div className="breakdown_table">
                        <table class="table last-tab">
                          <thead>
                            <tr>
                              <th scope="col" colspan="1"></th>
                              <th scope="col" colspan="3">
                                BULBAR
                              </th>
                              <th scope="col" colspan="3">
                                FINE MOTOR
                              </th>
                              <th scope="col" colspan="3">
                                GROSS MOTOR
                              </th>
                              <th scope="col" colspan="3">
                                RESPIRATORY
                              </th>
                              <th scope="col" colspan="3"></th>
                            </tr>
                            <tr>
                              <th scope="col">
                                Hover mouse over categories to view answers &amp;
                                scoring
                                <br />
                                <img
                                  src="./assets/images/breakdown-arrow.png"
                                  alt="left"
                                />
                              </th>
                              <th scope="col">Speech</th>
                              <th scope="col">Salivation</th>
                              <th scope="col">Swallowing</th>
                              <th scope="col">Handwriting</th>
                              <th scope="col">Cutting Food</th>
                              <th scope="col">Dressing and Hygiene</th>
                              <th scope="col">Turning in bed</th>
                              <th scope="col">Walking</th>
                              <th scope="col">Climbing stairs</th>
                              <th scope="col">Dyspnea</th>
                              <th scope="col">Orthopnea</th>
                              <th scope="col">Respiratory insufficiency</th>
                              <th scope="col">Total</th>
                            </tr>
                          </thead>
                          <tbody id="dtVerticalScrollExample">
                            {this.state.records.map((item, index) => {
                              return (
                                <tr key={index}>
                                  <th scope="row">{item.date}</th>
                                  <td
                                    style={{
                                      background:
                                        item.speech_score === 1
                                          ? "orange"
                                          : item.speech_score === 2
                                          ? "#ff0"
                                          : item.speech_score === 3
                                          ? "#adff2f"
                                          : item.speech_score === 4
                                          ? "#00ff04"
                                          : null,
                                    }}
                                  >
                                    {item.speech_score}
                                  </td>
                                  <td
                                    style={{
                                      background:
                                        item.salivation_score === 1
                                          ? "orange"
                                          : item.salivation_score === 2
                                          ? "#ff0"
                                          : item.salivation_score === 3
                                          ? "#adff2f"
                                          : item.salivation_score === 4
                                          ? "#00ff04"
                                          : null,
                                    }}
                                  >
                                    {item.salivation_score}
                                  </td>
                                  <td
                                    style={{
                                      background:
                                        item.swallowing_score === 1
                                          ? "orange"
                                          : item.swallowing_score === 2
                                          ? "#ff0"
                                          : item.swallowing_score === 3
                                          ? "#adff2f"
                                          : item.swallowing_score === 4
                                          ? "#00ff04"
                                          : null,
                                    }}
                                  >
                                    {item.swallowing_score}
                                  </td>
                                  <td
                                    style={{
                                      background:
                                        item.handwriting_score === 1
                                          ? "orange"
                                          : item.handwriting_score === 2
                                          ? "#ff0"
                                          : item.handwriting_score === 3
                                          ? "#adff2f"
                                          : item.handwriting_score === 4
                                          ? "#00ff04"
                                          : null,
                                    }}
                                  >
                                    {item.handwriting_score}
                                  </td>
                                  <td
                                    style={{
                                      background:
                                        item.cuttingfood_score === 1
                                          ? "orange"
                                          : item.cuttingfood_score === 2
                                          ? "#ff0"
                                          : item.cuttingfood_score === 3
                                          ? "#adff2f"
                                          : item.cuttingfood_score === 4
                                          ? "#00ff04"
                                          : null,
                                    }}
                                  >
                                    {item.cuttingfood_score}
                                  </td>
                                  <td
                                    style={{
                                      background:
                                        item.dressingandhygiene_score === 1
                                          ? "orange"
                                          : item.dressingandhygiene_score === 2
                                          ? "#ff0"
                                          : item.dressingandhygiene_score === 3
                                          ? "#adff2f"
                                          : item.dressingandhygiene_score === 4
                                          ? "#00ff04"
                                          : null,
                                    }}
                                  >
                                    {item.dressingandhygiene_score}
                                  </td>
                                  <td
                                    style={{
                                      background:
                                        item.turninginbed_score === 1
                                          ? "orange"
                                          : item.turninginbed_score === 2
                                          ? "#ff0"
                                          : item.turninginbed_score === 3
                                          ? "#adff2f"
                                          : item.turninginbed_score === 4
                                          ? "#00ff04"
                                          : null,
                                    }}
                                  >
                                    {item.turninginbed_score}
                                  </td>
                                  <td
                                    style={{
                                      background:
                                        item.walking_score === 1
                                          ? "orange"
                                          : item.walking_score === 2
                                          ? "#ff0"
                                          : item.walking_score === 3
                                          ? "#adff2f"
                                          : item.walking_score === 4
                                          ? "#00ff04"
                                          : null,
                                    }}
                                  >
                                    {item.walking_score}
                                  </td>
                                  <td
                                    style={{
                                      background:
                                        item.climbingstairs_score === 1
                                          ? "orange"
                                          : item.climbingstairs_score === 2
                                          ? "#ff0"
                                          : item.climbingstairs_score === 3
                                          ? "#adff2f"
                                          : item.climbingstairs_score === 4
                                          ? "#00ff04"
                                          : null,
                                    }}
                                  >
                                    {item.climbingstairs_score}
                                  </td>
                                  <td
                                    style={{
                                      background:
                                        item.dyspnea_score === 1
                                          ? "orange"
                                          : item.dyspnea_score === 2
                                          ? "#ff0"
                                          : item.dyspnea_score === 3
                                          ? "#adff2f"
                                          : item.dyspnea_score === 4
                                          ? "#00ff04"
                                          : null,
                                    }}
                                  >
                                    {item.dyspnea_score}
                                  </td>
                                  <td
                                    style={{
                                      background:
                                        item.orthopnea_score === 1
                                          ? "orange"
                                          : item.orthopnea_score === 2
                                          ? "#ff0"
                                          : item.orthopnea_score === 3
                                          ? "#adff2f"
                                          : item.orthopnea_score === 4
                                          ? "#00ff04"
                                          : null,
                                    }}
                                  >
                                    {item.orthopnea_score}
                                  </td>
                                  <td
                                    style={{
                                      background:
                                        item.respiratoryinsufficiency_score === 1
                                          ? "orange"
                                          : item.respiratoryinsufficiency_score === 2
                                          ? "#ff0"
                                          : item.respiratoryinsufficiency_score === 3
                                          ? "#adff2f"
                                          : item.respiratoryinsufficiency_score === 4
                                          ? "#00ff04"
                                          : null,
                                    }}
                                  >
                                    {item.respiratoryinsufficiency_score}
                                  </td>
                                  <td>{item.total}</td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                      </div>
                    )}
                    {this.state.client_code && this.state.is_loaded==true && (
                      <ProgressionChart 
                        clientCode={this.state.client_code}
                      />
                    )}                  
                    {this.state.records.length == 0 && (
                      <p className="text-center" style={customStyle}>
                        Not available.
                      </p>
                    )}
                  </Spin>
                </div>
                <div class="tab-pane fade" id="pills-contact" role="tabpanel" aria-labelledby="pills-contact-tab">
                  <Spin spinning={this.state.loading}>
                    {this.state.roads_list.length > 0 && (
                      <div className="breakdown_table roads_table" style={{maxHeight:470}}>
                        <table class="table last-tab">
                          <thead>
                            <tr>
                              <th scope="col">
                                Hover mouse over categories to view answers &amp;
                                scoring
                                <br />
                                <img
                                  src="./assets/images/breakdown-arrow.png"
                                  alt="left"
                                />
                              </th>
                              <th scope="col">Nod yes or no</th>
                              <th scope="col">Ride in a car</th>
                              <th scope="col">Eat soup</th>
                              <th scope="col">Drink milkshake or smoothie</th>
                              <th scope="col">Sit on a toilet </th>
                              <th scope="col">Swallow pills</th>
                              <th scope="col">Blow out a candle</th>
                              <th scope="col">Eat dry food</th>
                              <th scope="col">Speak on the phone</th>
                              <th scope="col">Drink out of a glass</th>
                              <th scope="col">Eat a large meal</th>
                              <th scope="col">Sign name on paper</th>
                              <th scope="col">Get into bed</th>
                              <th scope="col">Roll over in bed</th>
                              <th scope="col">Take a shower</th>
                              <th scope="col">Use a knife and fork</th>
                              <th scope="col">Walk around your home</th>
                              <th scope="col">Move a chair</th>
                              <th scope="col">Speak in a loud room</th>
                              <th scope="col">Speak for hours</th>
                              <th scope="col">Clip nails</th>
                              <th scope="col">Walk up 1 flight of stairs</th>
                              <th scope="col">Walk up a hill</th>
                              <th scope="col">Climb a stepstool</th>
                              <th scope="col">Get up from the floor</th>
                              <th scope="col">Carry an object going downstairs</th>
                              <th scope="col">Stand for hours</th>
                              <th scope="col">Get heavy objects off a high shelf</th>
                              <th scope="col">Total</th>
                            </tr>
                          </thead>
                          <tbody id="dtVerticalScrollExample">
                            {this.state.roads_list.map((item, index) => {
                              return (
                                <tr key={index}>
                                  <th scope="row">{item.date}</th>
                                  <td
                                    style={{
                                      background:
                                        {
                                          0: "red",
                                          1: "#ff0",
                                          2: "#00ff04",
                                        }[item.nod_yes_or_no_score] || null,
                                    }}
                                  >
                                    {item.nod_yes_or_no_score}
                                  </td>
                                  <td
                                    style={{
                                      background:
                                        {
                                          0: "red",
                                          1: "#ff0",
                                          2: "#00ff04",
                                        }[item.ride_in_a_car_score] || null,
                                    }}
                                  >
                                    {item.ride_in_a_car_score}
                                  </td>
                                  <td
                                    style={{
                                      background:
                                        {
                                          0: "red",
                                          1: "#ff0",
                                          2: "#00ff04",
                                        }[item.eat_soup_score] || null,
                                    }}
                                  >
                                    {item.eat_soup_score}
                                  </td>
                                  <td
                                    style={{
                                      background:
                                        {
                                          0: "red",
                                          1: "#ff0",
                                          2: "#00ff04",
                                        }[item.drink_milkshake_or_smoothie_score] ||
                                        null,
                                    }}
                                  >
                                    {item.drink_milkshake_or_smoothie_score}
                                  </td>
                                  <td
                                    style={{
                                      background:
                                        {
                                          0: "red",
                                          1: "#ff0",
                                          2: "#00ff04",
                                        }[item.sit_on_a_toilet_score] || null,
                                    }}
                                  >
                                    {item.sit_on_a_toilet_score}
                                  </td>
                                  <td
                                    style={{
                                      background:
                                        {
                                          0: "red",
                                          1: "#ff0",
                                          2: "#00ff04",
                                        }[item.swallow_pills_score] || null,
                                    }}
                                  >
                                    {item.swallow_pills_score}
                                  </td>
                                  <td
                                    style={{
                                      background:
                                        {
                                          0: "red",
                                          1: "#ff0",
                                          2: "#00ff04",
                                        }[item.blow_out_a_candle_score] || null,
                                    }}
                                  >
                                    {item.blow_out_a_candle_score}
                                  </td>
                                  <td
                                    style={{
                                      background:
                                        {
                                          0: "red",
                                          1: "#ff0",
                                          2: "#00ff04",
                                        }[item.eat_dry_food_score] || null,
                                    }}
                                  >
                                    {item.eat_dry_food_score}
                                  </td>
                                  <td
                                    style={{
                                      background:
                                        {
                                          0: "red",
                                          1: "#ff0",
                                          2: "#00ff04",
                                        }[item.speak_on_the_phone_score] || null,
                                    }}
                                  >
                                    {item.speak_on_the_phone_score}
                                  </td>
                                  <td
                                    style={{
                                      background:
                                        {
                                          0: "red",
                                          1: "#ff0",
                                          2: "#00ff04",
                                        }[item.drink_out_of_a_glass_score] || null,
                                    }}
                                  >
                                    {item.drink_out_of_a_glass_score}
                                  </td>
                                  <td
                                    style={{
                                      background:
                                        {
                                          0: "red",
                                          1: "#ff0",
                                          2: "#00ff04",
                                        }[item.eat_a_large_meal_score] || null,
                                    }}
                                  >
                                    {item.eat_a_large_meal_score}
                                  </td>
                                  <td
                                    style={{
                                      background:
                                        {
                                          0: "red",
                                          1: "#ff0",
                                          2: "#00ff04",
                                        }[item.sign_name_on_paper_score] || null,
                                    }}
                                  >
                                    {item.sign_name_on_paper_score}
                                  </td>
                                  <td
                                    style={{
                                      background:
                                        {
                                          0: "red",
                                          1: "#ff0",
                                          2: "#00ff04",
                                        }[item.get_into_bed_score] || null,
                                    }}
                                  >
                                    {item.get_into_bed_score}
                                  </td>
                                  <td
                                    style={{
                                      background:
                                        {
                                          0: "red",
                                          1: "#ff0",
                                          2: "#00ff04",
                                        }[item.roll_over_in_bed_score] || null,
                                    }}
                                  >
                                    {item.roll_over_in_bed_score}
                                  </td>
                                  <td
                                    style={{
                                      background:
                                        {
                                          0: "red",
                                          1: "#ff0",
                                          2: "#00ff04",
                                        }[item.take_a_shower_score] || null,
                                    }}
                                  >
                                    {item.take_a_shower_score}
                                  </td>
                                  <td
                                    style={{
                                      background:
                                        {
                                          0: "red",
                                          1: "#ff0",
                                          2: "#00ff04",
                                        }[item.use_a_knife_and_fork_score] || null,
                                    }}
                                  >
                                    {item.use_a_knife_and_fork_score}
                                  </td>
                                  <td
                                    style={{
                                      background:
                                        {
                                          0: "red",
                                          1: "#ff0",
                                          2: "#00ff04",
                                        }[item.walk_around_your_home_score] || null,
                                    }}
                                  >
                                    {item.walk_around_your_home_score}
                                  </td>
                                  <td
                                    style={{
                                      background:
                                        {
                                          0: "red",
                                          1: "#ff0",
                                          2: "#00ff04",
                                        }[item.move_a_chair_score] || null,
                                    }}
                                  >
                                    {item.move_a_chair_score}
                                  </td>
                                  <td
                                    style={{
                                      background:
                                        {
                                          0: "red",
                                          1: "#ff0",
                                          2: "#00ff04",
                                        }[item.speak_in_a_loud_room_score] || null,
                                    }}
                                  >
                                    {item.speak_in_a_loud_room_score}
                                  </td>
                                  <td
                                    style={{
                                      background:
                                        {
                                          0: "red",
                                          1: "#ff0",
                                          2: "#00ff04",
                                        }[item.speak_for_hours_score] || null,
                                    }}
                                  >
                                    {item.speak_for_hours_score}
                                  </td>
                                  <td
                                    style={{
                                      background:
                                        {
                                          0: "red",
                                          1: "#ff0",
                                          2: "#00ff04",
                                        }[item.clip_nails_score] || null,
                                    }}
                                  >
                                    {item.clip_nails_score}
                                  </td>
                                  <td
                                    style={{
                                      background:
                                        {
                                          0: "red",
                                          1: "#ff0",
                                          2: "#00ff04",
                                        }[item.walk_up_1_flight_of_stairs_score] ||
                                        null,
                                    }}
                                  >
                                    {item.walk_up_1_flight_of_stairs_score}
                                  </td>
                                  <td
                                    style={{
                                      background:
                                        {
                                          0: "red",
                                          1: "#ff0",
                                          2: "#00ff04",
                                        }[item.walk_up_a_hill_score] || null,
                                    }}
                                  >
                                    {item.walk_up_a_hill_score}
                                  </td>
                                  <td
                                    style={{
                                      background:
                                        {
                                          0: "red",
                                          1: "#ff0",
                                          2: "#00ff04",
                                        }[item.climb_a_stepstool_score] || null,
                                    }}
                                  >
                                    {item.climb_a_stepstool_score}
                                  </td>
                                  <td
                                    style={{
                                      background:
                                        {
                                          0: "red",
                                          1: "#ff0",
                                          2: "#00ff04",
                                        }[item.get_up_from_the_floor_score] || null,
                                    }}
                                  >
                                    {item.get_up_from_the_floor_score}
                                  </td>
                                  <td
                                    style={{
                                      background:
                                        {
                                          0: "red",
                                          1: "#ff0",
                                          2: "#00ff04",
                                        }[item.carry_an_object_going_downstairs_score] ||
                                        null,
                                    }}
                                  >
                                    {item.carry_an_object_going_downstairs_score}
                                  </td>
                                  <td
                                    style={{
                                      background:
                                        {
                                          0: "red",
                                          1: "#ff0",
                                          2: "#00ff04",
                                        }[item.stand_for_hours_score] || null,
                                    }}
                                  >
                                    {item.stand_for_hours_score}
                                  </td>
                                  <td
                                    style={{
                                      background:
                                        {
                                          0: "red",
                                          1: "#ff0",
                                          2: "#00ff04",
                                        }[item.get_heavy_objects_off_a_high_shelf_score] ||
                                        null,
                                    }}
                                  >
                                    {item.get_heavy_objects_off_a_high_shelf_score}
                                  </td>
                                  <td>{item.total}</td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                      </div>
                    )}
                    {this.state.roads_list.length == 0 && (
                      <p className="text-center" style={customStyle}>
                        Not available.
                      </p>
                    )}
                  </Spin>
                </div>
              </div>
            </div>
          )}
          {RESEARCH_TYPE=='Asymptomatic Study' && (
            <Spin spinning={this.state.loading}>
              {this.state.records.length > 0 && (
                <div className="breakdown_table">
                  <table class="table last-tab">
                    <thead>
                      <tr>
                        <th scope="col" colspan="1"></th>
                        <th scope="col" colspan="3">
                          BULBAR
                        </th>
                        <th scope="col" colspan="3">
                          FINE MOTOR
                        </th>
                        <th scope="col" colspan="3">
                          GROSS MOTOR
                        </th>
                        <th scope="col" colspan="3">
                          RESPIRATORY
                        </th>
                        <th scope="col" colspan="3"></th>
                      </tr>
                      <tr>
                        <th scope="col">
                          Hover mouse over categories to view answers &amp;
                          scoring
                          <br />
                          <img
                            src="./assets/images/breakdown-arrow.png"
                            alt="left"
                          />
                        </th>
                        <th scope="col">Speech</th>
                        <th scope="col">Salivation</th>
                        <th scope="col">Swallowing</th>
                        <th scope="col">Handwriting</th>
                        <th scope="col">Cutting Food</th>
                        <th scope="col">Dressing and Hygiene</th>
                        <th scope="col">Turning in bed</th>
                        <th scope="col">Walking</th>
                        <th scope="col">Climbing stairs</th>
                        <th scope="col">Dyspnea</th>
                        <th scope="col">Orthopnea</th>
                        <th scope="col">Respiratory insufficiency</th>
                        <th scope="col">Total</th>
                      </tr>
                    </thead>
                    <tbody id="dtVerticalScrollExample">
                      {this.state.records.map((item, index) => {
                        return (
                          <tr key={index}>
                            <th scope="row">{item.date}</th>
                            <td
                              style={{
                                background:
                                  item.speech_score === 1
                                    ? "orange"
                                    : item.speech_score === 2
                                    ? "#ff0"
                                    : item.speech_score === 3
                                    ? "#adff2f"
                                    : item.speech_score === 4
                                    ? "#00ff04"
                                    : null,
                              }}
                            >
                              {item.speech_score}
                            </td>
                            <td
                              style={{
                                background:
                                  item.salivation_score === 1
                                    ? "orange"
                                    : item.salivation_score === 2
                                    ? "#ff0"
                                    : item.salivation_score === 3
                                    ? "#adff2f"
                                    : item.salivation_score === 4
                                    ? "#00ff04"
                                    : null,
                              }}
                            >
                              {item.salivation_score}
                            </td>
                            <td
                              style={{
                                background:
                                  item.swallowing_score === 1
                                    ? "orange"
                                    : item.swallowing_score === 2
                                    ? "#ff0"
                                    : item.swallowing_score === 3
                                    ? "#adff2f"
                                    : item.swallowing_score === 4
                                    ? "#00ff04"
                                    : null,
                              }}
                            >
                              {item.swallowing_score}
                            </td>
                            <td
                              style={{
                                background:
                                  item.handwriting_score === 1
                                    ? "orange"
                                    : item.handwriting_score === 2
                                    ? "#ff0"
                                    : item.handwriting_score === 3
                                    ? "#adff2f"
                                    : item.handwriting_score === 4
                                    ? "#00ff04"
                                    : null,
                              }}
                            >
                              {item.handwriting_score}
                            </td>
                            <td
                              style={{
                                background:
                                  item.cuttingfood_score === 1
                                    ? "orange"
                                    : item.cuttingfood_score === 2
                                    ? "#ff0"
                                    : item.cuttingfood_score === 3
                                    ? "#adff2f"
                                    : item.cuttingfood_score === 4
                                    ? "#00ff04"
                                    : null,
                              }}
                            >
                              {item.cuttingfood_score}
                            </td>
                            <td
                              style={{
                                background:
                                  item.dressingandhygiene_score === 1
                                    ? "orange"
                                    : item.dressingandhygiene_score === 2
                                    ? "#ff0"
                                    : item.dressingandhygiene_score === 3
                                    ? "#adff2f"
                                    : item.dressingandhygiene_score === 4
                                    ? "#00ff04"
                                    : null,
                              }}
                            >
                              {item.dressingandhygiene_score}
                            </td>
                            <td
                              style={{
                                background:
                                  item.turninginbed_score === 1
                                    ? "orange"
                                    : item.turninginbed_score === 2
                                    ? "#ff0"
                                    : item.turninginbed_score === 3
                                    ? "#adff2f"
                                    : item.turninginbed_score === 4
                                    ? "#00ff04"
                                    : null,
                              }}
                            >
                              {item.turninginbed_score}
                            </td>
                            <td
                              style={{
                                background:
                                  item.walking_score === 1
                                    ? "orange"
                                    : item.walking_score === 2
                                    ? "#ff0"
                                    : item.walking_score === 3
                                    ? "#adff2f"
                                    : item.walking_score === 4
                                    ? "#00ff04"
                                    : null,
                              }}
                            >
                              {item.walking_score}
                            </td>
                            <td
                              style={{
                                background:
                                  item.climbingstairs_score === 1
                                    ? "orange"
                                    : item.climbingstairs_score === 2
                                    ? "#ff0"
                                    : item.climbingstairs_score === 3
                                    ? "#adff2f"
                                    : item.climbingstairs_score === 4
                                    ? "#00ff04"
                                    : null,
                              }}
                            >
                              {item.climbingstairs_score}
                            </td>
                            <td
                              style={{
                                background:
                                  item.dyspnea_score === 1
                                    ? "orange"
                                    : item.dyspnea_score === 2
                                    ? "#ff0"
                                    : item.dyspnea_score === 3
                                    ? "#adff2f"
                                    : item.dyspnea_score === 4
                                    ? "#00ff04"
                                    : null,
                              }}
                            >
                              {item.dyspnea_score}
                            </td>
                            <td
                              style={{
                                background:
                                  item.orthopnea_score === 1
                                    ? "orange"
                                    : item.orthopnea_score === 2
                                    ? "#ff0"
                                    : item.orthopnea_score === 3
                                    ? "#adff2f"
                                    : item.orthopnea_score === 4
                                    ? "#00ff04"
                                    : null,
                              }}
                            >
                              {item.orthopnea_score}
                            </td>
                            <td
                              style={{
                                background:
                                  item.respiratoryinsufficiency_score === 1
                                    ? "orange"
                                    : item.respiratoryinsufficiency_score === 2
                                    ? "#ff0"
                                    : item.respiratoryinsufficiency_score === 3
                                    ? "#adff2f"
                                    : item.respiratoryinsufficiency_score === 4
                                    ? "#00ff04"
                                    : null,
                              }}
                            >
                              {item.respiratoryinsufficiency_score}
                            </td>
                            <td>{item.total}</td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              )}
              {this.state.records.length == 0 && (
                <p className="text-center" style={customStyle}>
                  Not available.
                </p>
              )}
            </Spin>
          )}
        </div>
      </div>
    );
  }
}
